/** The supplier's share on top of a base cost; undefined for a supplier with no profit share rate. */
export function supplierProfitShare(
  profitShareRate: number | null | undefined,
  baseCost: number | null,
): number | null | undefined {
  if (!profitShareRate) {
    return undefined;
  }

  return baseCost === null ? null : baseCost / (1 - profitShareRate) - baseCost;
}

export function withProfitShare(baseCost: number | null, profitShare: number | null | undefined): number | null {
  return baseCost === null ? null : baseCost + (profitShare ?? 0);
}
